/* eslint-disable tsdoc/syntax */
import * as React from "react";
import { SVGProps } from "react";
export const EmptyCart = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 80 79" width="2em" height="1em" fill="none" {...props}>
    <path
      stroke="#E67068"
      strokeLinecap="round"
      strokeWidth={1.264}
      d="M40.939 18.67v7.065"
    />
    <g stroke="#E67068" strokeLinecap="round" strokeWidth={1.579}>
      <path d="M14.863 9.083v5.046M17.47 11.606h-5.214" />
    </g>
    <g stroke="#E67068" strokeLinecap="round" strokeWidth={0.948}>
      <path d="M62.32 3.532V6.56M63.885 5.046h-3.129" />
    </g>
    <path
      stroke="#E67068"
      strokeLinecap="round"
      strokeWidth={1.264}
      d="m47.432 24.01-1.8 1.43M33.638 22.203l2.719 3.458"
    />
    <path
      stroke="#C9D0D6"
      strokeWidth={0.632}
      d="M56.584 22.518c.411 0 .727.32.727.694 0 .373-.316.693-.727.693-.412 0-.728-.32-.728-.693 0-.373.317-.694.728-.694ZM22.164 23.528c.7 0 1.249.546 1.25 1.198 0 .652-.55 1.198-1.25 1.198s-1.249-.546-1.249-1.198c0-.652.55-1.198 1.25-1.198Z"
    />
    <path
      stroke="#E67068"
      strokeWidth={0.948}
      d="M47.718 10.566c.905 0 1.613.706 1.613 1.545 0 .838-.708 1.545-1.613 1.545s-1.612-.707-1.612-1.545c0-.839.707-1.545 1.612-1.545Z"
    />
    <path
      stroke="#E67068"
      strokeWidth={1.264}
      d="M33.116.632c1.11 0 1.975.866 1.975 1.891s-.864 1.891-1.975 1.891c-1.111 0-1.976-.866-1.976-1.89 0-1.026.865-1.892 1.976-1.892Z"
    />
    <path
      fill="#E7EBEE"
      d="M4.794 66.144 0 39.36h78.112L73.04 70.977a7.994 7.994 0 0 1-7.894 6.733H13.584a7.986 7.986 0 0 1-7.858-6.536l-.932-5.03Z"
    />
    <path
      fill="#C9D0D6"
      d="m0 39.36 11.466-8.442a2 2 0 0 1 1.186-.389h53.172a2 2 0 0 1 1.203.402l11.2 8.429H0Z"
    />
    <path
      fill="#9EA7B0"
      d="M11.995 39.36v-8.238a.3.3 0 0 0-.478-.241L0 39.36h11.995ZM66.867 39.36 66.5 30.5l11.727 8.86h-11.36Z"
    />
    <ellipse cx={30.174} cy={49.807} fill="#C9D0D6" rx={2.086} ry={2.018} />
    <ellipse cx={48.976} cy={49.807} fill="#C9D0D6" rx={2.086} ry={2.018} />
    <circle cx={49.059} cy={50.019} r={1.175} fill="#B7BFC7" />
    <circle cx={29.976} cy={50.019} r={1.175} fill="#B7BFC7" />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.329}
      d="M29.655 51.139v-9.094c0-4.93 4.384-8.925 9.792-8.925 5.409 0 9.793 3.996 9.793 8.925v9.094"
    />
  </svg>
);
